<div *ngIf="displayMetadata" 
  class="docs-container t-small">
  <a (click)="showMetadata = !showMetadata">
    {{ "translate.cat.catMatchedPhraseMetadata" | translate }}
    <span [ngClass]="!showMetadata ? 'pi pi-angle-down' : 'pi pi-angle-up'"></span>
  </a>
<slide-in-out [isOpen]="showMetadata" style="padding-left: 5px; padding-top: 5px; display: block">
    <div *ngFor="let catMatchedPhraseMetadata of catMatchedPhrasesMetadata" class="l-flex t-row--small docs-tbl">
      <ng-container *ngIf="catMatchedPhraseMetadata.is_display_metadata">
        <dl class="t-columns t-panel-small l-cell-spread-x">
          <div class="t-key-value-pair-box" style="font-size: initial !important;">
            <div class="l-align-spaceBetween">
              <dt class="field">{{ catMatchedPhraseMetadata.field_name }}:</dt>
              <dd class="value">{{ catMatchedPhraseMetadata.field_values | join:separator }}</dd>
            </div>
        </div>
        </dl>
      </ng-container>
    </div>
</slide-in-out>